import type { Scene } from "@babylonjs/core";

/** The render loop draws one scene at a time: the lobby or the room (spec 2o §4.1). */
export class SceneSwitch {
  constructor(private current: Scene) {}

  show(s: Scene): void { this.current = s; }

  shown(): Scene { return this.current; }

  frame(): void { if (this.current.activeCamera) this.current.render(); }
}
